'use strict';
var expiringId;
const MAX_SESSION_LENGTH = 30 * 60 * 1000;
const MAX_IDLE_SESSION_LENGTH = 30 * 60 * 1000;
const EMPLOYEE_MAX_SESSION_LENGTH = 4 * 60 * 60 * 1000;
const EMPLOYEE_MAX_IDLE_SESSION_LENGTH = 60 * 60 * 1000;
const IDLE_TIMEOUT_TIME = 60 * 1000; 
var maxSessionLength = MAX_SESSION_LENGTH;
var maxIdleSessionLength = MAX_IDLE_SESSION_LENGTH;

function checkCompanyRepFunctions(p) {
  if (p === undefined) {return;}

  if (p.gs === undefined ) {return;}

  var access = false;
  if (p.gs.indexOf('a10006') > -1 || p.gs.indexOf('a10016') > -1 || p.gs.indexOf('a10001') > -1)
    {access = true;}

  if (!access) {return; } 

  $('#getStatusMenuItem').show();

  for (var i=0; i<p.gs.length; i++) {
    var g = p.gs[i];
    $('.'+g).show();  
  }
}


function checkAgentFunctions(p) {
  if (p === undefined) {return;}

  if (p.gs === undefined ) {return;}

  if ( p.gs.indexOf('a10012') > -1)
  {
    $('.agentLink').hide();
    return;
  }

  $('.agentLink').hide();

  for (var i=0; i<p.gs.length; i++) {
    var g = p.gs[i];
    $('.'+g).show();  
  }
}



function checkFunctions(p) {
  if (p === undefined) {return;}

  if (p.gs === undefined ) {return;}

  for (var i=0; i<p.gs.length; i++) {
    var g = p.gs[i];
    $('.'+g).show();  
  }
}


function signout(logoutApi, logoutUrl) {

  if (localStorage.principal === undefined) {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie = 'pSession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.location.href = logoutUrl;
    return;
  }

  var p = JSON.parse(localStorage.principal);
  localStorage.clear();
  sessionStorage.clear();
  document.cookie = 'pSession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

  if (p.userType === 'Employee') {
    logoutUrl = '/index.html';
  }

  $('#loggingOut').show();
  $.ajax({
    type: 'POST',
    dataType: 'json',

    contentType : 'application/json',
    url: logoutApi,
    headers : {Authorization : p.pToken},
    data : JSON.stringify({})

  })
    .done(function(ret, status, xhr) {
      console.log(ret);
      window.location.href = logoutUrl;

    })
    .fail(function(ret) {
      console.log('error: '+ret);
      window.location.href = logoutUrl; 
    });

}


function touchSession() {
  if (expiringId !== undefined) {
    clearInterval(expiringId);
  }
  $('#sessionTimerBlock').hide();
  const d = new Date().getTime();;
  if (!localStorage.sessionStart)
    localStorage.sessionStart = d
  localStorage.sessionTime = d;
}

function sessionExpiring(logoutApi, logoutUrl) {
  console.log("sessionExpiring!");
  expiringId = setInterval(function() {
    var d = new Date().getTime();
    const sessionDuration = d - parseInt(localStorage.sessionStart);
    const idleSessionDuration = d - parseInt(localStorage.sessionTime);

    if (sessionDuration > maxSessionLength || idleSessionDuration > maxIdleSessionLength) { 
      clearInterval(expiringId);
      signout(logoutApi, logoutUrl);
    } else if (idleSessionDuration <= maxIdleSessionLength - IDLE_TIMEOUT_TIME) { 
      clearInterval(expiringId);
      $('#sessionTimerBlock').hide();
    } else { 
      $('#sessionTimer').text(Math.floor((maxIdleSessionLength - idleSessionDuration) / 1000));
      $('#sessionTimerBlock').show();
    }
  }, 1000);
}


function checkSession(logoutApi, logoutUrl) {
  var d = new Date().getTime();
  if (localStorage.sessionStart && localStorage.sessionTime) {
    const sessionDuration = d - parseInt(localStorage.sessionStart);
    const idleSessionDuration = d - parseInt(localStorage.sessionTime);

    if (sessionDuration > maxSessionLength || idleSessionDuration > maxIdleSessionLength - IDLE_TIMEOUT_TIME) {
      sessionExpiring(logoutApi, logoutUrl);
      return false;
    }
  } else {
    localStorage.sessionTime = d;
  }
  return true;
}

function onLoggedon(logoutApi, logoutUrl) {
  if (localStorage.principal) {

    $('#classicLogin').remove();

    var p = JSON.parse(localStorage.principal);
    if (p.userType === 'Employee') {
      maxSessionLength = EMPLOYEE_MAX_SESSION_LENGTH;
      maxIdleSessionLength = EMPLOYEE_MAX_IDLE_SESSION_LENGTH;
    }

    if (!checkSession()) {return; }

    touchSession();

    if (p.userType === 'Employee') {
      $('#adminMenuItem').show();
      $('.agentMenu').hide();
      $('#agentProfileMenu').hide();
      $('#companyAdminMenu').hide();
      checkFunctions(p);
    } else if(p.userType === 'Agent' ) {
      $('#getStatusMenuItem').show();
      $('#companyAdminMenu').hide();
      checkAgentFunctions(p);  
    } else if(p.userType === 'CompanyAdmin') {
      $('#getStatusMenuItem').show();
      $('#companyAdminMenu').show();
      $('.agentLink').hide();
      checkFunctions(p);
    } else if(p.userType === 'CompanyRep') {
      $('#getStatusMenuItem').hide();
      $('#companyAdminMenu').hide();
      $('.agentLink').hide();
      checkCompanyRepFunctions(p);
    }

    if (p.userType === 'Client') {
      return;
    }

    $('#principalHeader').text('Hi '+ p['given_name']);

    $('#loginMenu').hide();
    $('#logoutMenu').show();

    if(p.matchingStatus !== 'Deferred'){

      $('#agentLinkProfileMenu').hide();
    }

    setInterval( function() {checkSession(logoutApi, logoutUrl);}, 10000);
  }
  else {
    console.log('No principal');

    $('#adminMenuItem').hide();
    $('#logoutMenu').hide();
  }
}

